module.exports = __webpack_public_path__ + "img/logo.6f560b1c.png";